export function openClose() {
    const openCloseText = "open-close";
    const openCloseBtn = $(".open-close-btn");

    openCloseBtn.on("click", function (e) {
        e.preventDefault();

        $(this).closest(".open-close").toggleClass("active");
    });
}









// WEBPACK FOOTER //
// ./assets/js/modules/openClose.js